import { render, staticRenderFns } from "./SectionAttachmentList.vue?vue&type=template&id=74eb96d0"
import script from "./SectionAttachmentList.vue?vue&type=script&lang=js"
export * from "./SectionAttachmentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports